<template>
  <b-modal
    id="disconnectionAlert"
    centered
    :no-close-on-backdrop="true"
    :hide-header="true"
    :hide-footer="true"
  >
    <div class="disconnection-wrapper">
      <div class="title">{{ $t('text.lost_internet_connection') }}</div>
      <div class="content">
        <div class="mb-30">{{ $t('text.check_setting') }}.</div>
        <div class="text-right mb-10 bottom-text">
          <i class="el-icon-loading" style="font-size: 16px"></i>
          <span class="ml-5">{{ $t('text.trying_to_reconnect') }}...</span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import store from '../store/store'
export default {
  data() {
    return {
      checkConnectionTimer: '',
      timer: '',
      disconnectionSeconds: 0
    }
  },
  mounted() {
    this.checkConnectionTimer = setInterval(this.checkConnection, 5000)
  },
  methods: {
    checkConnection() {
      let user = JSON.parse(localStorage.getItem('user'))
      if (!user) return false
      ApiService.CheckConnection()
        .then(response => {
          if (response.data.success) {
            store.commit('user/SET_IS_INTERNET_ERROR', false)
            this.resetTimer()
          } else {
            store.commit('user/SET_IS_INTERNET_ERROR', true)
            this.startTimer()
          }
        })
        .catch(error => {
          if (typeof error.response == 'undefined') {
            store.commit('user/SET_IS_INTERNET_ERROR', true)
            this.startTimer()
          }
        })
    },
    startTimer() {
      if (!this.timer) {
        let vm = this
        this.timer = setInterval(function() {
          vm.disconnectionSeconds = vm.disconnectionSeconds + 10
          if (vm.disconnectionSeconds >= 300) {
            vm.$bvModal.show('disconnectionAlert')
          }
        }, 10000)
      }
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timer = ''
      this.disconnectionSeconds = 0
      this.$bvModal.hide('disconnectionAlert')
    }
  },
  beforeDestroy() {
    clearInterval(this.checkConnectionTimer)
  }
}
</script>
